import {Injectable} from "@angular/core";
import {UserService} from "./UserService";
import {Location as LocationService} from "@angular/common";

@Injectable()
export class AuthorizationHelperService {

    constructor(
        private userService: UserService,
        private location: LocationService) {
    }

    isAuthorized(): boolean {
        return !!(this.userService.user && this.userService.user.token);
    }

    getToken(): string {
        var token: string;

        if (this.isAuthorized()) {
            token = this.userService.user.token;
        }

        return token;
    }

    onError(rejection: any): boolean {
        var unAuthorized: boolean = rejection.status === 401;
        var forbidden: boolean = rejection.status === 403;

        if (unAuthorized) {
            this.location.go("/login");
        }
        else if (forbidden) {
            this.location.go("/unauthorized");
        }
        return unAuthorized;
    }
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Authorization/AuthorizationHelperService.ts